import { useTranslation } from 'react-i18next';
import { ActionsColumn as ActionsColumnCommon, ActionType } from '@otp/ui';
import { Assign } from '@otp/icons';
import styles from './index.module.css';
import { useState } from 'react';
import {
  ActionModals,
  WttpQuestionnaireResponseAction,
} from './actions-modals';
import { WttpQuestionnaireResponsesData } from 'src/components/wttp/questionnaire-responses/list/types';
import { Can, useCan } from 'src/utils/can';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';

type ActionsColumProps = {
  wttpQuestionnaireResponse: WttpQuestionnaireResponsesData;
  onActionFinished?: (action: WttpQuestionnaireResponseAction) => void;
  className?: string;
};

export const ActionsColumn = ({
  className,
  wttpQuestionnaireResponse,
  onActionFinished,
}: ActionsColumProps) => {
  const { t } = useTranslation();
  const [action, setAction] = useState<WttpQuestionnaireResponseAction>();
  const { can } = useCan();
  const actions: ActionType[] = [];

  if (
    can({
      action: Actions.Assign,
      subject: Subjects.QuestionnaireResponses,
      appArea: AppArea.Wttp,
    })
  ) {
    actions.push({
      id: WttpQuestionnaireResponseAction.Assign,
      label: t('common.assign'),
      icon: <Assign />,
      onClick: () => setAction(WttpQuestionnaireResponseAction.Assign),
    });
  }

  return (
    <Can
      I={Actions.Write}
      a={Subjects.QuestionnaireResponses}
      appArea={AppArea.Wttp}
    >
      <div onClick={(e) => e.stopPropagation()} className={className}>
        <ActionsColumnCommon
          actions={actions}
          classes={{ menu: styles.actionsColumn }}
        />
        {action && (
          <ActionModals
            questionnaireResponse={wttpQuestionnaireResponse}
            onClose={() => setAction(undefined)}
            action={action}
            onActionFinished={onActionFinished}
          />
        )}
      </div>
    </Can>
  );
};
